/**
 * SetupRow — click-to-open settings row for the immersive-setup screen:
 * icon chip + label + value/summary + chevron. Brand tokens only.
 */
import { ChevronRight } from "lucide-react";
import type { GenieIconName } from "@/components/ui/genie-icons/genie-icons";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

interface SetupRowProps {
  genieIcon: GenieIconName;
  tint?: string;
  label: string;
  /** Current value / summary shown on the right */
  value?: string;
  onClick?: () => void;
  className?: string;
}

export const SetupRow = ({ genieIcon, tint = "#4E9CFF", label, value, onClick, className }: SetupRowProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl border border-gray-200 bg-white hover:bg-genie-background transition-colors text-left ${className ?? ""}`}
    >
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: `${tint}1a` }}
      >
        <GenieIcon name={genieIcon} size={18} color={tint} />
      </div>
      <span className="flex-1 min-w-0 text-sm font-semibold text-[#222B45]">{label}</span>
      {value && <span className="text-sm text-gray-500 truncate max-w-[45%]">{value}</span>}
      <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
    </button>
  );
};

export default SetupRow;
